import React, { useEffect } from "react";
import AnnouncementBar from "./announcement-bar";
import Header from "./mobile";
import ScheduledOrdersModal from "components/account/subscription/scheduled-orders/modal";
import { useDispatch, useSelector } from "react-redux";
import OfferBar from "./offer-bar";
import { SET_HAS_OFFER_BAR } from "utils/action-types";
import DesktopHeader from "./desktop";

const HeaderWrapper = ({ context, pageSettings }) => {
	const { announcementBar, desktop, mobile, generalOfferBar } = context;
	const { path, hideAnnouncementBanner, hideHeaderNav = false, showOfferBar, showAuthOfferBar, offerBar } = pageSettings;
	const { authenticated } = useSelector((state) => state.account.profile);
	const dispatch = useDispatch();

	const hideBarForLoggedInCustomers = authenticated && announcementBar?.hide;

	const showOffer = authenticated ? showAuthOfferBar : showOfferBar;

	useEffect(() => {
		dispatch({ type: SET_HAS_OFFER_BAR, payload: !hideHeaderNav && showOffer });
	},[]);
	
	return (
		<>
			{announcementBar && !hideAnnouncementBanner && !hideBarForLoggedInCustomers && <AnnouncementBar data={announcementBar} />}
			{!hideHeaderNav && <Header data={mobile} path={path}>
				{(generalOfferBar || offerBar) && showOffer && <OfferBar data={offerBar} generalData={generalOfferBar} />}
			</Header>
			}
			{!hideHeaderNav && desktop && <DesktopHeader data={desktop} path={path}>
				{(generalOfferBar || offerBar) && showOffer && <OfferBar data={offerBar} generalData={generalOfferBar} />}
			</DesktopHeader>}
			<ScheduledOrdersModal />
		</>
	);
};

export default HeaderWrapper;